module.exports = __webpack_public_path__ + "img/pin_substitution_red.7e56af10.svg";